/** Enum for different search result options */
export enum DisplayedSearchResultType {
  Routes = 'routes',
  Lines = 'lines',
}
